import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DataInfo } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InfoService {
  constructor(private http: HttpClient) {}

  public getDataInfo(): Observable<DataInfo> {
    return this.http.get<DataInfo>(`${environment.calculationApi}/info`);
  }
}
